export default __webpack_public_path__ + "static/media/MDI - instagram.df970887.svg";